import { render, staticRenderFns } from "./UETableMenu.vue?vue&type=template&id=c3af0480&scoped=true&"
import script from "./UETableMenu.vue?vue&type=script&lang=js&"
export * from "./UETableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3af0480",
  null
  
)

export default component.exports